"use client";

import { useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import * as Flex from "@repo/ui/flex";
import FaqLink, { FaqType } from "../link/faq-link";

export type LinkListProps = {
  faqs: FaqType[];
  showArrow: boolean;
  gap?: "2xs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
};

const LinkList = ({
  faqs = [],
  gap,
  showArrow,
}: LinkListProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!isEditing && (!faqs || faqs.length === 0)) {
    return <></>;
  }

  return (
    <Flex.Container column gap={gap}>
      {faqs?.map((topic, index) => {
        return <FaqLink key={index} faq={topic} showArrow={showArrow} />;
      })}
    </Flex.Container>
  );
};

export default LinkList;
